<template>
    <div class="row">
        <div class="col-12">
            <p class="card-subtitle mb-3">
                Ha seleccionado la categoría: <b>{{ data.category ? data.category.name : '' }}</b>
                en horario de <b>{{ timereplace }}</b> con fecha <b>{{ data.date }}</b>.
                <br>
                Proporcione sus datos en el siguiente formulario para continuar con la reserva.
            </p>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label>Nombre : <span class="text-danger">*</span></label>
                <input type="text" class="form-control" name="first_name" :disabled="add ? false : user ? user.first_name : false" v-model="data.first_name">
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>Apellido : <span class="text-danger">*</span></label>
                <input type="text" class="form-control" name="last_name" :disabled="add ? false : user ? user.last_name : false" v-model="data.last_name">
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>Teléfono : <span class="text-danger">*</span></label>
                <input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="8" oninput="this.value = this.value.replace(/[^0-9]/g, '');" placeholder="Ej: 55555555" class="form-control" name="phone" :disabled="add ? false : user ? user.phone : false" v-model="data.phone">
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>Correo electrónico : <span class="text-danger">*</span></label>
                <input type="email" class="form-control" name="email" :disabled="add ? false : user ? user.email : false" v-model="data.email">
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label>Detalle : <span class="text-danger">*</span></label>
                <textarea class="form-control" name="detail" rows="5" v-model="data.detail"></textarea>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    timereplace () {
      return this.data.time ? this.data.time.replace(/-/g, 'a') : ''
    }
  },
  data () {
    return {
      add: this.$route.query.add || false
    }
  },
  created () {
    if (this.user) {
      this.data.first_name = this.user.first_name
      this.data.last_name = this.user.last_name
      this.data.email = this.user.email
      this.data.phone = this.user.phone
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/steps/Details.vue